import { vars } from '../../theme';

const baseStyles = {
    display: {
        fontFamily: vars.fonts.body,
        fontWeight: 700
    },
    serifDisplay: {
        fontFamily: vars.fonts.display,
        fontWeight: 700
    },
    title: {
        fontFamily: vars.fonts.body,
        fontWeight: 600
    },
    subtitle: {
        fontFamily: vars.fonts.body,
        fontWeight: 600,
        textTransform: 'uppercase'
    },
    body: {
        fontFamily: vars.fonts.body,
        fontWeight: 400
    },
    emphasis: {
        fontFamily: vars.fonts.body,
        fontWeight: 600
    }
} as const;

export const newTextStyles = {
    display56: {
        ...baseStyles.display,
        fontSize: '56px',
        lineHeight: '60px'
    },
    display48: {
        ...baseStyles.display,
        fontSize: '48px',
        lineHeight: '50px'
    },
    display40: {
        ...baseStyles.display,
        fontSize: '40px',
        lineHeight: '44px'
    },
    display32: {
        ...baseStyles.display,
        fontSize: '32px',
        lineHeight: '34px'
    },
    display24: {
        ...baseStyles.display,
        fontSize: '24px',
        lineHeight: '26px'
    },
    display20: {
        ...baseStyles.display,
        fontSize: '20px',
        lineHeight: '26px'
    },
    serifDisplay56: {
        ...baseStyles.serifDisplay,
        fontSize: '56px',
        lineHeight: '60px'
    },
    serifDisplay48: {
        ...baseStyles.serifDisplay,
        fontSize: '48px',
        lineHeight: '50px'
    },
    serifDisplay40: {
        ...baseStyles.serifDisplay,
        fontSize: '40px',
        lineHeight: '44px'
    },
    serifDisplay32: {
        ...baseStyles.serifDisplay,
        fontSize: '32px',
        lineHeight: '34px'
    },
    serifDisplay24: {
        ...baseStyles.serifDisplay,
        fontSize: '24px',
        lineHeight: '26px'
    },
    title20: {
        ...baseStyles.title,
        fontSize: '20px',
        lineHeight: '24px'
    },
    title18: {
        ...baseStyles.title,
        fontSize: '18px',
        lineHeight: '22px'
    },
    title16: {
        ...baseStyles.title,
        fontSize: '16px',
        lineHeight: '19px'
    },
    title14: {
        ...baseStyles.title,
        fontSize: '14px',
        lineHeight: '17px'
    },
    subtitle16: {
        ...baseStyles.subtitle,
        fontSize: '16px',
        lineHeight: '20px'
    },
    subtitle14: {
        ...baseStyles.subtitle,
        fontSize: '14px',
        lineHeight: '18px'
    },
    subtitle12: {
        ...baseStyles.subtitle,
        fontSize: '12px',
        lineHeight: '14px'
    },
    body32: {
        ...baseStyles.body,
        fontSize: '32px',
        lineHeight: '40px'
    },
    body24: {
        ...baseStyles.body,
        fontSize: '24px',
        lineHeight: '32px'
    },
    body22: {
        ...baseStyles.body,
        fontSize: '22px',
        lineHeight: '30px'
    },
    body20: {
        ...baseStyles.body,
        fontSize: '20px',
        lineHeight: '28px'
    },
    body18: {
        ...baseStyles.body,
        fontSize: '18px',
        lineHeight: '26px'
    },
    body16: {
        ...baseStyles.body,
        fontSize: '16px',
        lineHeight: '22px'
    },
    body15: {
        ...baseStyles.body,
        fontSize: '15px',
        lineHeight: '20px'
    },
    body14: {
        ...baseStyles.body,
        fontSize: '14px',
        lineHeight: '18px'
    },
    body12: {
        ...baseStyles.body,
        fontSize: '12px',
        lineHeight: '15px'
    },
    body10: {
        ...baseStyles.body,
        fontSize: '10px',
        lineHeight: '13px'
    },
    emphasis40: {
        ...baseStyles.emphasis,
        fontSize: '40px',
        lineHeight: '48px'
    },
    emphasis32: {
        ...baseStyles.emphasis,
        fontSize: '32px',
        lineHeight: '40px'
    },
    emphasis24: {
        ...baseStyles.emphasis,
        fontSize: '24px',
        lineHeight: '32px'
    },
    emphasis22: {
        ...baseStyles.emphasis,
        fontSize: '22px',
        lineHeight: '30px'
    },
    emphasis20: {
        ...baseStyles.emphasis,
        fontSize: '20px',
        lineHeight: '28px'
    },
    emphasis18: {
        ...baseStyles.emphasis,
        fontSize: '18px',
        lineHeight: '26px'
    },
    emphasis16: {
        ...baseStyles.emphasis,
        fontSize: '16px',
        lineHeight: '22px'
    },
    emphasis15: {
        ...baseStyles.emphasis,
        fontSize: '15px',
        lineHeight: '20px'
    },
    emphasis14: {
        ...baseStyles.emphasis,
        fontSize: '14px',
        lineHeight: '18px'
    },
    emphasis12: {
        ...baseStyles.emphasis,
        fontSize: '12px',
        lineHeight: '15px'
    },
    emphasis10: {
        ...baseStyles.emphasis,
        fontSize: '10px',
        lineHeight: '13px'
    }
} as const;
